import { useCallback, useEffect, useState } from 'react'

export const RESEND_COOLDOWN_SECONDS = 60

export const formatCountdown = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = `${totalSeconds % 60}`.padStart(2, '0')
  return `${minutes}:${seconds}`
}

// Cooldown between verification-code resends. Idle on mount (the first code
// was just sent by the auth step); `start` arms it when the user resends and
// `stop` clears it, e.g. when the resend request fails.
function useResendCountdown() {
  const [secondsLeft, setSecondsLeft] = useState(0)

  useEffect(() => {
    if (secondsLeft <= 0) return undefined

    const timerId = setTimeout(() => { setSecondsLeft(current => current - 1) }, 1000)

    return () => clearTimeout(timerId)
  }, [secondsLeft])

  const start = useCallback(() => { setSecondsLeft(RESEND_COOLDOWN_SECONDS) }, [])
  const stop = useCallback(() => { setSecondsLeft(0) }, [])

  return { secondsLeft, start, stop }
}

export default useResendCountdown
